<template lang="pug">
list-item-card
  div(slot="header")
    .columns.align-center
      item-col.column(label="ordem_servico_analise.analista" :value="analise.analista.nome")
      .column.col-auto.mt-2
        span(:class="analiseSituacaoClasses[analise.situacao] + ' label'")
          | {{ $i18n.t(`enums.db.enum_ordem_servico_analise_situacao.${analise.situacao}`) }}
    .columns
      item-col.col-12.mt-2(label="ordem_servico.assunto" :value="analise.ordem_servico.assunto.descricao")
      item-col.col-3.mt-2(label="OS-m número" :value="`${analise.ordem_servico.numero}/${analise.ordem_servico.ano}`")
      item-col.col-3.mt-2(label="OS-m emitida em" :value="analise.created_at | date")
      item-col.col-3.mt-2(label="Protocolo" :value="`${String(analise.ordem_servico.protocolo_numero) || '-'}/${String(analise.ordem_servico.protocolo_ano) || '-'}`")
      item-col.col-3.mt-2(label="ordem_servico.protocolo_tipo" :value="analise.ordem_servico | enums('ordem_servico.protocolo_tipo')")
      item-col.col-12.mt-2(label="cadastro.contribuinte" :value="contribuinteLabel")
      item-col.col-6.col-sm-12.mt-2(label="cadastro.numero" :value="analise.ordem_servico.cadastro.numero")
      item-col.col-6.col-sm-12.mt-2(label="cadastro.tipo" :value="analise.ordem_servico.cadastro | enums('cadastro.tipo')")
  .columns(slot="footer")
    .column.mt-2
      small(class="label")
        | {{ analise.created_at | date }}
    .column.col-auto
      router-link.btn.btn-link.tooltip.tooltip-left(
        :data-tooltip="'views.buttons.show.label' | translate",
        :to="to"
      )
        btn-content(name="show")
</template>

<script>
import { analiseSituacaoClasses } from "@/lib/constants"
import { cpfCnpj } from "@/lib/masks"

export default {
  props: {
    analise: { type: Object, required: true },
    to: { type: Object, required: true },
  },
  computed: {
    contribuinteLabel() {
      const { contribuinte } = this.analise.ordem_servico.cadastro || {}
      if (!contribuinte) return ""
      return `${cpfCnpj(contribuinte.cpf_cnpj)} - ${contribuinte.razao_social}`
    },
    analiseSituacaoClasses() {
      return analiseSituacaoClasses
    },
  },
}
</script>
